/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert CSV to JSON and JSON back to CSV. Paste your data, pick a direction, and copy the result. Everything runs in your browser.`)
};

const es_cj_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte CSV a JSON y JSON a CSV. Pega tus datos, elige una dirección y copia el resultado. Todo se ejecuta en tu navegador.`)
};

const de_cj_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konvertiere CSV zu JSON und JSON zurück zu CSV. Füge deine Daten ein, wähle eine Richtung und kopiere das Ergebnis. Alles läuft in deinem Browser.`)
};

const nl_cj_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converteer CSV naar JSON en JSON terug naar CSV. Plak uw gegevens, kies een richting en kopieer het resultaat. Alles werkt in uw browser.`)
};

const fr_cj_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertissez CSV en JSON et JSON en CSV. Collez vos données, choisissez une direction et copiez le résultat. Tout s'exécute dans votre navigateur.`)
};

const it_cj_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti CSV in JSON e JSON in CSV. Incolla i tuoi dati, scegli una direzione e copia il risultato. Tutto funziona nel tuo browser.`)
};

const pt_br2_cj_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta CSV para JSON e JSON de volta para CSV. Cole seus dados, escolha uma direção e copie o resultado. Tudo funciona no seu navegador.`)
};

const pt_cj_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta CSV para JSON e JSON para CSV. Cole os seus dados, escolha uma direção e copie o resultado. Tudo funciona no seu navegador.`)
};

const ja_cj_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV を JSON に変換し、JSON を CSV に戻します。データを貼り付けて方向を選択し、結果をコピーします。すべてブラウザで実行されます。`)
};

const zh_cj_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 CSV 转换为 JSON，也可将 JSON 转回 CSV。粘贴数据、选择转换方向，然后复制结果。一切都在你的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_intro", locale)
	if (locale === "en") return en_cj_intro(inputs)
	if (locale === "es") return es_cj_intro(inputs)
	if (locale === "de") return de_cj_intro(inputs)
	if (locale === "nl") return nl_cj_intro(inputs)
	if (locale === "fr") return fr_cj_intro(inputs)
	if (locale === "it") return it_cj_intro(inputs)
	if (locale === "pt-BR") return pt_br2_cj_intro(inputs)
	if (locale === "pt") return pt_cj_intro(inputs)
	if (locale === "ja") return ja_cj_intro(inputs)
	return zh_cj_intro(inputs)
};